import { render, staticRenderFns } from "./FileBrowser.vue?vue&type=template&id=4fddcce2&scoped=true&lang=html"
import script from "./FileBrowser.vue?vue&type=script&lang=js"
export * from "./FileBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fddcce2",
  null
  
)

export default component.exports